import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "M14 8.166a1.17 1.17 0 0 1 1.167 1.167V14A1.17 1.17 0 0 1 14 15.166 1.17 1.17 0 0 1 12.833 14V9.333A1.17 1.17 0 0 1 14 8.166m-.012-5.833C7.548 2.333 2.333 7.56 2.333 14s5.215 11.666 11.655 11.666c6.452 0 11.679-5.226 11.679-11.666S20.44 2.333 13.988 2.333m.012 21A9.33 9.33 0 0 1 4.667 14 9.33 9.33 0 0 1 14 4.666 9.33 9.33 0 0 1 23.333 14 9.33 9.33 0 0 1 14 23.333m1.167-3.5h-2.334V17.5h2.334z"
    }, null, -1)
  ]))]))
}
export default { render: render }